import { Maybe } from 'maybe-not';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';

export default function keepAlive(platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('keepAlive')) {
        return;
    }
    return function() {
        sendMessage('keepAlive', Maybe.nothing<string>());
    };
}
